// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Kw7","content":"styles_content__3maqP"};